import { HTTP } from '../helpers/http-common.js'
import authHeader from '../helpers/auth-header'
import helpers from '../helpers/helpers'
import config from '@/config'

const itemsService = {
  getItems,
  getItemProducts,
  storeItem,
  updateItem,
  getItemDetail,
  deleteItem,
  uploadImportFile,
  deleteAllItems
};

export default itemsService

function getItems(page = 0, search = {}) {
  var headers = {
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()
    }
  }

  let params = '';

  if(search.term) {
    params += `&search=${search.term}`;
  }

  if(search.options) {
    params += `&options=${search.options}`
  }

  if(search.perPage) {
    params += `&perPage=${search.perPage}`
  }

  if (search.export) {
    params += `&export=${search.export}`
    headers.responseType = 'blob';
  }

  return HTTP.get(`items?page=${page}${params}`, headers);
}

function getItemProducts(page = 0, search = {}) {

  let params = '';

  if(search.term) {
    params += `&search=${search.term}`;
  }

  if(search.options) {
    params += `&options=${search.options}`
  }

  if(search.perPage) {
    params += `&perPage=${search.perPage}`
  }

  return HTTP.get(`item-products?page=${page}${params}`, {
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()
    }
  });
}

function getItemDetail(id) {
  return HTTP.get(`item/${id}`, {
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()

    }
  });
}

function storeItem(item = {}) {
  return HTTP({
    method: 'post',
    url: 'store-item',
    data: item,
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()

    }
  });
}

function updateItem(item = {}) {
  return HTTP({
    method: 'post',
    url: 'update-item',
    data: item,
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()
    }
  });
}

function deleteItem(id) {
  return HTTP({
    method: 'post',
    url: 'delete-item',
    data: {id: id},
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()
    }
  });
}

function uploadImportFile() {
  return {
    url: config.url_api+'/items-import',
    headers: {
      'Access-Control-Allow-Origin': '*',
      'Access-Control-Allow-Methods': 'GET, POST, OPTIONS, PUT, DELETE',
      'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept, X-File-Name, X-File-Size, X-File-Type',
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()
    }
  }
}

function deleteAllItems() {
  return HTTP({
    method: 'post',
    url: 'delete-all-items',
    headers: {
      'Authorization': authHeader(),
      'x-Company': helpers.getCompanyId()
    }
  });
}